import {get} from '@/bank/bankApi.service'
import {ref, watch} from 'vue'
import {useEmitter} from '@/services/infrastructure/emitter'
import {NO_ORG_SELECTED, ORG_SELECTED, ORG_SWITCHED} from '@/types/events'
import { Transaction} from '@/bank/bank.types'
import {BANK_TRANSACTION_CREATED, BANK_TRANSACTION_UPDATED} from '@/bank/bank.events'

const {onEvents} = useEmitter()

export function useTransactionService() {
    //const selectedAccount = ref<BankAccount | undefined>(undefined)
    const selectedAccount = ref<any>()
    const transactions = ref<Transaction[]>([])

    const fetchTransactions = async (): Promise<Transaction[]> => {
        if (!selectedAccount.value) return []
        return await get(`/transactions/${selectedAccount.value.bban}`)
    }

    watch(selectedAccount, async () => {
        transactions.value = await fetchTransactions()
    })

    const clear = () => {
        transactions.value = []
        selectedAccount.value = undefined
    }

    onEvents([ORG_SELECTED, ORG_SWITCHED, NO_ORG_SELECTED], clear)
    onEvents([BANK_TRANSACTION_CREATED, BANK_TRANSACTION_UPDATED], () => fetchTransactions())
    return {
        selectedAccount,
        transactions
    }
}
